import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AppContext } from "../context/AppContext";

const Appoinments = () => {
  const { doctId } = useParams();
  const { doctors,symbol } = useContext(AppContext);
  const [info, setInfo] = useState(null);
  // const [docSlots,setDocSlots]=useState([])
  // const [slotIndex,setSlotIndex]=useState(0)  
  // const [slotTime,setSlotTime]=useState("")   

  const getAvailableSlots= async( )=> {

  }
  const FetchDoctId = async () => {
    const InfoDoctors = doctors.find((doc) => doctId === doc._id);
    setInfo(InfoDoctors);
  };
  useEffect(() => {
    FetchDoctId();
    console.log(info);
  }, [doctors, doctId]);
  useEffect(()=>{ 
getAvailableSlots()
  },[info])

  return (
    info && (
      
      <div className=" flex rounded-xl flex-col md:flex-row border gap-4   ">
        
        <div className="bg-blue-50 relative">
          <h1 className="absolute text-black font-medium text-3xl px-3 py-3 m-1 h-20 top-0  right-0">{info.fees}{symbol}</h1>
          <img className=" h-[300px] w-[600px]" src={info.image} alt="wef" />
        </div>

        <div className="flex flex-col items-start justify-center p-3 gap-4">
          <h1 className="text-2xl font-medium">{info.name}</h1>
          <h1 >{info.speciality}</h1>
          <h1>{info.degree}</h1>
          <h1>{info.experience}</h1>
          <ul>
            <li>{info.address.line1}</li>
            <li>{info.address.line2}</li>
          </ul>
          <p className="text-sm ">{info.about}</p>
        </div>
      </div>
    )
  );
};

export default Appoinments;
